import { useEffect, useState } from "react";
import { toast } from "sonner";
import { AdminGuard, AdminTitle } from "@/components/admin/AdminGuard";
import { errText } from "@/lib/api";
import { adminRestock, adminRestockCsv } from "@/lib/admin";

const Panel = () => {
  const [d, setD] = useState(null);
  useEffect(() => { adminRestock().then(setD).catch((e) => toast.error(errText(e))); }, []);
  const csv = async () => { const b = await adminRestockCsv(); const a = document.createElement("a"); a.href = URL.createObjectURL(b); a.download = "restock-alerts.csv"; a.click(); };
  if (!d) return <p className="label pt-10 text-ink/60">Loading…</p>;
  return (
    <>
      <AdminTitle right={<button onClick={csv} className="btn btn-ink" data-testid="admin-restock-csv">Export CSV</button>}>Restock alerts</AdminTitle>
      <p className="mt-6 max-w-xl text-sm text-ink/70">Back-in-stock emails send automatically (once per alert) when a variant's stock goes above 0.</p>
      <table className="mt-6 w-full text-left text-sm" data-testid="admin-restock-groups">
        <thead><tr className="label border-b border-ink/15 text-ink/60"><th className="py-3">Product</th><th>Colour</th><th>Size</th><th>Waiting</th><th>Notified</th><th>Failed</th></tr></thead>
        <tbody>{d.groups.map((g) => (
          <tr key={`${g.product_slug}-${g.color}-${g.size}`} className="border-b border-ink/10" data-testid={`admin-restock-group-${g.product_slug}-${g.size}`}><td className="py-3">{g.product_name}</td><td>{g.color}</td><td className="font-mono">{g.size}</td><td>{g.waiting}</td><td>{g.notified}</td><td>{g.failed}</td></tr>
        ))}</tbody>
      </table>
      {!d.groups.length && <p className="py-8 text-ink/60" data-testid="admin-restock-empty">No alerts yet.</p>}
      <h2 className="label mt-12 font-bold">All alerts · {d.rows.length}</h2>
      <ul className="mt-3 font-mono text-xs" data-testid="admin-restock-rows">{d.rows.map((r, i) => <li key={i} className="flex flex-wrap justify-between gap-3 border-b border-ink/5 py-2"><span>{r.email}</span><span>{r.product_slug} · {r.color} · {r.size}</span><span className={r.status === "notified" ? "font-bold" : ""}>{r.status}</span></li>)}</ul>
    </>
  );
};

export default function AdminRestock() {
  return <AdminGuard><Panel /></AdminGuard>;
}
